import Shipment from '../../../types/api/shipment'

/** В наборе форм отгрузки есть формы без отметки о браке или поломке — по ним идёт расход красок. */
export function hasActiveForms(shipment?: Shipment | null) {
    return (shipment?.form_set?.forms ?? []).some(
        form => !form.dateOfFailure && !form.failureReason
    )
}
